/*
 * delivery-eta.js (HYPEST)
 * Eén vaste levertijdzin, geen datumberekening en geen aftelklok.
 * Kassa en vertrouwen 2026-09-28: de oude berekening telde zaterdag als
 * verzenddag. Het magazijn verstuurt
 * alleen op werkdagen, dus we tonen overal dezelfde zin uit de taalbestanden
 * (hypest.trust.eta). Deze fallback geldt alleen als die tekst leeg is.
 * Taal volgt document.documentElement.lang (nl/en/de/fr/es).
 */
(function () {
  'use strict';

  var COPY = {
    nl: 'Op werkdagen besteld voor 22u is op dezelfde dag verzonden.',
    en: 'Order on a weekday before 10 PM and we ship the same day.',
    de: 'Versand an Werktagen — Lieferung in Europa meist in 1 bis 5 Werktagen.',
    fr: 'Expédition les jours ouvrés — livraison en Europe généralement sous 1 à 5 jours ouvrés.',
    es: 'Envío en días laborables — entrega en Europa normalmente en 1 a 5 días laborables.',
  };

  function locale() {
    var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
    if (window.Shopify && window.Shopify.locale) {
      lang = String(window.Shopify.locale).slice(0, 2).toLowerCase();
    }
    return COPY[lang] ? lang : 'nl';
  }

  function render(el) {
    var textEl = el.querySelector('[data-delivery-eta-text]');
    if (!textEl) return;
    if ((textEl.textContent || '').trim()) return;
    textEl.textContent = COPY[locale()];
  }

  function init() {
    document.querySelectorAll('[data-delivery-eta]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', init);
  document.addEventListener('shopify:section:load', init);
})();
